window.addEventListener("load", function(){

 var acc = document.querySelector(".accordion");

  acc.onclick = function(){
  
 var show = document.querySelector(".panel");
    show.classList.toggle("active");
}

  var element = $("#shopify-section-header .header-wrapper .site-header");
   

  $(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       element.addClass('active-hdr');
    } else {
       element.removeClass('active-hdr');
    }
});
  
    
});


